const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	$domAuthRoutes: [
		'/wp-json/office-pulse-api/v1/review/create',
		'/wp-json/office-pulse-api/v1/company/toggle-subscriber',
		'/wp-json/office-pulse-api/v1/auth/register',
		'/wp-json/office-pulse-api/v1/user/toggle-follower',
		'/wp-json/office-pulse-api/v1/review/vote'
	],

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.rangeSlider();
		this.fetchCheckAuth(this.$domAuthRoutes);
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const formId = e.detail.id;

			$(formId).parents(formHolder).addClass(sentClass);

			setTimeout(() => {
				$(formHolder).removeClass(sentClass);
			}, delay);
		}, false);
	},
	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},
	rangeSlider() {
		const elRangeInputs = document.querySelectorAll('.range');

		function setProgress(elTarget) {
			const elRangeBar = elTarget.parentElement;
			const intThumbWidth = elRangeBar.clientHeight * 3;
			const intRangeBarWidth = elRangeBar.clientWidth - intThumbWidth;
			const intThumbWidthOffset = intThumbWidth / 2;
			const intProgressPosition = (elTarget.value - elTarget.min) / (elTarget.max - elTarget.min);
			const intRangePosition = (intRangeBarWidth * intProgressPosition) + intThumbWidthOffset;

			elRangeBar.style.background =
				'linear-gradient(to right, #5c92ff ' +
				intRangePosition + 'px, #e2e2ea ' +
				intRangePosition + 'px';
		}

		for (let i = 0; i < elRangeInputs.length; i++) {
			elRangeInputs[i].firstElementChild.addEventListener('input', function() {
				setProgress(this);
			});
			setProgress(elRangeInputs[i].firstElementChild);
		}
	},

	fetchCheckAuth: function(authRoutes) {
		// Save the original fetch method
		const originalFetch = window.fetch;

		// Override fetch
		window.fetch = async function(url, options = {}) {
			// Check if the URL requires Authorization
			const requiresAuth = authRoutes.some((route) => url.includes(route));

			if (requiresAuth) {
				// Ensure headers are defined
				const headers = options.headers || {};

				// Check for Authorization header
				if (!headers.Authorization && $('body.page-template-page-register').length < 1) {
					console.warn('Authorization header missing, redirecting to login...');
					window.location.href = window.origin + '/login';
					return Promise.reject(new Error('Unauthorized: Missing Authorization header'));
				}

				try {
					// Call the original fetch method
					const response = await originalFetch(url, options);

					// Check if the response is unauthorized
					if (response.status === 401 || response.status === 403 && $('body.page-template-page-register').length < 1) {
						console.warn('Unauthorized response, redirecting to login...');
						window.location.href = window.origin + '/login';
						return Promise.reject(new Error('Unauthorized: Invalid Authorization header'));
					}

					return response;
				} catch (error) {
					console.error('Fetch failed:', error);
					throw error; // Re-throw the error so it can be handled by the caller
				}
			}

			// For non-auth routes, proceed with the original fetch
			return originalFetch(url, options);
		};
	}

};

export default FormHelpers;
